var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusBeneficios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8331 6.33337H41.1664V15.8334H34.8331V6.33337ZM60.1664 34.8334H69.6664V41.1667H60.1664V34.8334ZM53.8331 40.4067V38C53.8331 29.26 46.7398 22.1667 37.9998 22.1667C29.2598 22.1667 22.1664 29.26 22.1664 38H9.49978C8.39145 38 7.37811 38.57 6.80811 39.4884C6.23811 40.4067 6.17478 41.5784 6.68144 42.56L19.3481 67.8934C19.6113 68.4156 20.0139 68.8548 20.5113 69.1622C21.0088 69.4696 21.5817 69.6333 22.1664 69.635H63.3331C64.4414 69.635 65.4548 69.065 66.0248 68.1467C66.5948 67.2284 66.6581 66.0567 66.1514 65.075L53.8331 40.4067ZM48.7031 44.3334L51.8698 50.6667H39.1714L36.0048 44.3334H48.7031ZM28.9114 44.3334L32.0781 50.6667H17.7964L14.6298 44.3334H28.9114ZM20.9631 57H35.2448L38.4114 63.3334H24.1298L20.9631 57ZM45.5048 63.3334L42.3381 57H55.0364L58.2031 63.3334H45.5048ZM51.4264 20.0767L53.6748 22.325L55.9231 24.5734L59.2798 21.2167L62.6365 17.86L60.3881 15.6117L58.1398 13.3634L54.7831 16.72L51.4264 20.0767ZM15.6114 15.6117L13.3631 17.86L16.7198 21.2167L20.0764 24.5734L22.3248 22.325L24.5731 20.0767L21.2164 16.72L17.8598 13.3634L15.6114 15.6117Z",
    fill: "#97EC5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBeneficios);
export default __webpack_public_path__ + "static/media/status-beneficios.69acdcf601aa3326b20e2d3b7ebb7ab6.svg";
export { ForwardRef as ReactComponent };